import React from "react";
import {Box, Card, CircularProgress, Fab, Typography} from "@material-ui/core";
import Popover from "@mui/material/Popover/Popover";


export const CardContainer = (props) => (
    <Box mb={3}>
        <Card sx={{ p: 3 }}  mb={3}>
            {props.children}
        </Card>
    </Box>
);

export const InfoPop = (props) => {

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    if(props.children) {

        return (<>
            <Fab size="small" aria-describedby={id} variant="contained" onClick={handleClick}>
                <Typography sx={{fontSize: 26}}>?</Typography>
            </Fab>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}

            >
                <Box sx={{width: 400, padding: 2}}>
                    {props.children}
                </Box>
            </Popover>
        </>);
    }
    return '';

};


export const LoadingBox = () =>(
    <Box sx={{ display: 'flex' }} justifyContent="center" m={2}>
        <CircularProgress color="primary" />
    </Box>
);
export const BigTitle = (props) => (
    <div className="slideTitle">
        <Typography align="center" variant="h2" sx={{textTransform: 'uppercase'}}>
            {props.children}
        </Typography>
    </div>
)